var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 801 801",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400.717,
    cy: 400.073,
    r: 400,
    fill: "#1111FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M529.521 258.13C537.739 250.175 542.848 239.027 542.848 226.686C542.848 203.692 525.112 184.84 502.574 183.065L502.525 182.928H499.22C499.177 182.928 499.133 182.928 499.09 182.928C499.046 182.928 499.003 182.928 498.959 182.928H258.342C253.924 182.928 250.342 186.51 250.342 190.928V250.293C250.342 254.711 253.924 258.293 258.342 258.293H414.472L167.121 505.643H282.229L529.579 258.293L529.521 258.13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.84 609.219V549.854C556.84 545.436 553.258 541.854 548.84 541.854H392.71L640.061 294.503H524.953L277.602 541.854L277.661 542.017C269.443 549.972 264.334 561.12 264.334 573.461C264.334 596.455 282.07 615.306 304.607 617.082L304.656 617.219H308.092H548.84C553.258 617.219 556.84 613.637 556.84 609.219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/logo-circle.ec864630315b497df6d6a2e640c911d3.svg";
export { ForwardRef as ReactComponent };